import { Chip, styled } from '@mui/material';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { MaggieFeatureFlags } from '../../../util/feature-flags';
import { FIELD_PILLS, FieldPill, PILL_LABEL } from './fieldManagerModels';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

interface FieldTypePillsProps {
  selected: FieldPill;
  onChange: (pill: FieldPill) => void;
}

export function FieldTypePills({ selected, onChange }: FieldTypePillsProps) {
  const { showFormulaFields } = useFlags<MaggieFeatureFlags>();
  const pills = FIELD_PILLS.filter((pill) => pill !== 'formula' || showFormulaFields);
  return (
    <Wrapper>
      {pills.map((pill) => {
        const isSelected = pill === selected;
        return (
          <Chip
            key={pill}
            label={PILL_LABEL[pill]}
            onClick={() => onChange(pill)}
            variant={isSelected ? 'filled' : 'outlined'}
            color={isSelected ? 'primary' : 'default'}
          />
        );
      })}
    </Wrapper>
  );
}
